import WithRender from "../../templates/containers/pageOptionAllAttributesContainer.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getActiveProductPageOptions", "getActivePageOptions"])
  },

  methods: {
    IsActive: function (pageOption) {
      return pageOption === this.getActivePageOptions;
    }
  },
  props: ["hideContainer"]
});
